import { connect } from 'react-redux';
import BusBookOnBehalfField from '../components/BusBookOnBehalf/BusBookOnBehalfField';
import { selectBookOnBehalfAgentName } from '../selectors/busBookingAgentAutoCompleteSelector';
import setBookOnBehalf from '../actions/setBookOnBehalf';

const mapStateToProps = state => ({
  bookOnBehalf: state.bus.bookingSearchForm.bookOnBehalf,
  bookOnBehalfAgentId: state.bus.bookingSearchForm.agentId,
  bookOnBehalfAgentName: selectBookOnBehalfAgentName(state),
});

const mapDispatchToProps = dispatch => ({
  setBookOnBehalf: bookOnBehalf => dispatch(setBookOnBehalf(bookOnBehalf)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BusBookOnBehalfField);
